// eslint-disable-next-line @wix/santa-editor/scoped-imports
import { createHook, createPromiseHook } from '@/apilib/hooks';

import type { EditorBaseHooks } from '@/editorCore';

export const createEditorBaseHooks = (): EditorBaseHooks => ({
  tabChanged: createHook(),
  siteCreationCreatePresets: createHook(),
  editorBuildAndRender: createPromiseHook(),
  createInstallAppsHooks: createPromiseHook(),
  sectionsMigrationStarted: createPromiseHook<{
    migrationSkipCount: number;
  }>(),
  sectionsMigrationReady: createPromiseHook<{
    isMigrated: boolean;
    error?: Error | unknown;
  }>(),
  isSiteCreationUiVisible: createPromiseHook(),
});
